module.exports = __webpack_public_path__ + "static/blog-logo-b3d7cb713a2292bc47e66069aa08138a.png";